/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_Out_Reason_For_SaleInputs */

const vi_pll_out_reason_for_sale = /** @type {(inputs: Pll_Out_Reason_For_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất bán / đơn hàng`)
};

/**

* @param {Pll_Out_Reason_For_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_out_reason_for_sale = /** @type {((inputs?: Pll_Out_Reason_For_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_Out_Reason_For_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_out_reason_for_sale(inputs)
});